import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  /**
   * @type {HTMLTableElement}
   */
  table = null

  /**
   * @type {HTMLDivElement}
   */
  header = null

  connect() {
    this.header = this.element.querySelector(':scope > .sticky-table-header')
    this.table = this.element.querySelector(':scope > table')

    if(this.header) {
      this.table.style.setProperty('--sticky-top', `${this.header.offsetHeight}px`)
    }
  }
}
